/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Import Form
import {
  Form,
  Col,
  Row,
  FormControl,
  Button,
  Container,
} from "react-bootstrap";

/* eslint-enable */

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

//import Moment JS
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

// Import Modal
import Modal from "react-bootstrap/Modal";

//Import Accordion
import Accordion from "react-bootstrap/Accordion";

//Import Tab
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

//Import service
import approveService from "../../services/approve.service";
import FarmerService from "../../services/farmer.service";
import uploadService from "../../services/uploadfile.service";
import apihostname from "../../services/apihostname";

//Import CSS
// import "./Modaladddetail.css";

function ModalViewApprove(props) {
  const [assoc, setAssoc] = useState([]);
  const [farmer, setFarmer] = useState({});
  const [key, setKey] = useState("direct");
  const [mastersent, setMastersent] = useState([]);
  const [directsent, setDirectsent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deed, setDeed] = useState([]);
  const [files, setFiles] = useState([]);

  const listfile = (regid) => {
    setLoading(true);
    uploadService
      .listfile(regid)
      .then((response) => {
        setFiles(response.data.data);
      })
      .catch((err) => toast.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    // initialForm();
    setAssoc([]);
    props.hidden(false);
  };
  const getMember = (reg_id) => {
    approveService.getMember(reg_id).then((data) => {
      if (data.data.success) {
        setAssoc(data.data.data);
      }
    });
  };
  const getDirect = (reg_id) => {
    approveService.getDirect(reg_id).then((data) => {
      if (data.data.success) {
        setDirectsent(data.data.data);
      }
    });
  };
  const getMaster = (reg_id) => {
    approveService.getMaster(reg_id).then((data) => {
      if (data.data.success) {
        setMastersent(data.data.data);
      }
    });
  };
  const getDeed = (reg_id) => {
    approveService.getDeed(reg_id).then((data) => {
      if (data.data.success) {
        setDeed(data.data.data);
      }
    });
  };
  const getFarmer = (farmer_idcard) => {
    FarmerService.getFarmerById(farmer_idcard).then((data) => {
      setFarmer(data.data.farmer);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (Object.keys(props.farmerselect).length > 0 && props.farmerselect) {
      getMember(props.farmerselect.regsugar_id);
      getFarmer(props.farmerselect.person_card_id);
      getDirect(props.farmerselect.regsugar_id);
      getMaster(props.farmerselect.regsugar_id);
      getDeed(props.farmerselect.regsugar_id);
      listfile(props.farmerselect.regsugar_id);
    }
  }, [props.farmerselect.regsugar_id]);

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>อนุมัติการจดทะเบียน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey="0" alwaysOpen>
            <Accordion.Item eventKey="0">
              <Accordion.Header>ข้อมูลพื้นฐาน</Accordion.Header>
              <Accordion.Body>
                <div className="farmer-profile-img">
                  <img
                    src={
                      process.env.REACT_APP_API +
                      "/images/farmer/" +
                      farmer.farmer_image
                    }
                    alt="No Image"
                    width="150"
                    height="150"
                  />
                </div>
                <br />
                <span>บัตรประชาชน : </span> {farmer.id_card}
                <br />
                <span>ชื่อ - นามสกุล : </span>{" "}
                {farmer.pre_name +
                  " " +
                  farmer.first_name +
                  " " +
                  farmer.last_name}
                <br />
                <span>ที่อยู่ : </span>{" "}
                {farmer.address +
                  " แขวง/ตำบล " +
                  farmer.tam_namt +
                  " เขต/อำเภอ " +
                  farmer.amp_namt +
                  " จังหวัด " +
                  farmer.prov_namt}
                <br />
                <span>เพศ : </span>
                {farmer.sex}
                <br />
                <span>วันเกิด : </span>
                {moment(farmer.birth_date)
                  .add(543, "year")
                  .locale("th")
                  .format("ll")}
                <br />
                <span>เบอร์โทร : </span>
                {farmer.tel}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>ข้อมูลการเป็นสมาชิกสถาบัน</Accordion.Header>
              <Accordion.Body>
                {assoc.map((item, key) => {
                  return (
                    <li key={key} className="cademy-ui" name={item.assoc_id}>
                      {item.assoc_name}
                    </li>
                  );
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>ข้อมูลการส่งอ้อย</Accordion.Header>
              <Accordion.Body>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-3"
                >
                  <Tab eventKey="direct" title="ส่งตรงโรงงาน">
                    <Row>
                      {directsent.map((item, key) => {
                        return (
                          <li
                            key={key}
                            className="cademy-ui"
                            name={item.factory_id}
                          >
                            {" ชื่อโรงงาน : " +
                              item.factory_name +
                              " ส่งอ้อย : " +
                              item.amount +
                              " ตัน"}
                          </li>
                        );
                      })}
                    </Row>
                  </Tab>
                  <Tab eventKey="passMaster" title="ส่งผ่านหัวหน้ากลุ่ม">
                    <Row>
                      {mastersent.map((item, key) => {
                        return (
                          <li key={key} className="cademy-ui">
                            {item.master_person_id +
                              " ชื่อ - สกุล : " +
                              item.master_name +
                              " ส่งอ้อย : " +
                              item.master_factory_name +
                              " " +
                              item.amount +
                              " ตัน"}
                          </li>
                        );
                      })}
                    </Row>
                  </Tab>
                </Tabs>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>ข้อมูลการปลูกอ้อย</Accordion.Header>
              <Accordion.Body>
                {" "}
                <Row>
                  {deed.map((item, key) => {
                    return (
                      <li
                        key={key}
                        className="cademy-ui"
                        name={item.deed_number}
                      >
                        {"เลขที่ดิน : " +
                          item.deed_number +
                          " ประเภท : " +
                          item.deed_type +
                          " การเช่า : " +
                          item.deed_rent +
                          " ชื่อเจ้าของที่ดิน : " +
                          item.deed_owner +
                          " เนื้อที่ : " +
                          item.deed_rai +
                          " ไร่"}
                      </li>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>Download เอกสาร</Accordion.Header>
              <Accordion.Body>
                {files.map((item, key) => {
                  return (
                    <li key={key}>
                      {item}
                      <a
                        href={
                          apihostname +
                          "/uploads/" +
                          props.farmerselect.regsugar_id +
                          "/" +
                          item
                        }
                        download={item}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button
                          className="btn btn-primary btn-sm"
                          style={{ padding: "0.3rem" }}
                        >
                          download
                        </button>
                      </a>
                    </li>
                  );
                })}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalViewApprove;

ModalViewApprove.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  farmerselect: PropTypes.object,
  setdata: PropTypes.func,
};

ModalViewApprove.defaultProps = {
  farmerselect: { farmer_id: 0, farmer_idcard: 0 },
};
